import axios from '@/services/api'

/**
 * @param {string} query
 *
 * @returns {Promise<Object>}
 */
export const fetchForumCategories = (query = '') => {
	const url = `/api/forum-categories?${query}`
	return axios.get(url)
}

/**
 * @param {string} query
 *
 * @returns {Promise<Object>}
 */
export const fetchForums = (query = '') => {
	const url = `/api/forums?${query}`
	return axios.get(url)
}

/**
 * @param {number} forumId
 *
 * @returns {Promise<Object>}
 */
export const getForum = (forumId) => {
	const url = `/api/forums/${forumId}`
	return axios.get(url)
}

/**
 * @param {number} forumId
 *
 * @returns {Promise<Object>}
 */
export const getForumComments = (forumId) => {
	const url = `/api/thread-replies?thread_id=${forumId}`
	return axios.get(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const threadCategoryToggleFollow = (data) => {
	const url = `/api/thread-category-follow`
	return axios.post(url, data)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addPost = (data) => {
	const url = `/api/forums`
	return axios.post(url, data)
}

/**
 * @param {String} id
 *
 * @returns {Promise<Object>}
 */
export const threadCategoryToggleUnFollow = (id) => {
	const url = `/api/thread-category-follow/${id}`
	return axios.delete(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const forumFollow = (data) => {
	const url = `/api/forum-follow`
	return axios.post(url, data)
}

/**
 * @param {String} id
 *
 * @returns {Promise<Object>}
 */
export const forumUnfollow = (id) => {
	const url = `/api/forum-follow/${id}`
	return axios.delete(url)
}
